import ls from 'local-storage';
import moment from 'moment';
import 'moment/locale/ru';
import '@/js/desktop/components/jsCarousel/jsCarousel';
import Vue, { reactive } from 'vue';
import useVueCompositionApi from '@/js/common/plugins/use-vue-composition-api';
import '@/css/desktop/redesignHeader.scss';
import { HotelLeadBanner } from '@pages/hotel';
import { mountLibSearchForm, getHotelPageFlow } from '@features/libSearchFormIntegration';
import { checkLeadSession } from '@entities/lead';

import HotelTrackingService from '@ve/pages/hotel/analytics/yandexAnalytics/hotelTrackingService';
import HotelPagePriceJumpTrackingService from '@ve/pages/hotel/analytics/yandexAnalytics/HotelPagePriceJumpTrackingService';
import HotelPageSearch from '@/js/common/Domain/Service/hotelSearch/HotelPageSearch';
import TourCriteriaObjectValue from '@/js/common/Domain/ObjectValue/TourCriteria';
import ADVCakeService from '@/js/common/Domain/Service/ADVCake';
import TourProductsRepository from '@/js/common/Domain/Repository/TourProducts';
import toRouterHotelHydrator from '@/js/common/Domain/Hydrator/toRouterHotel';
import searchSessionService from '@/js/common/Domain/Service/search/searchSession';
import CountriesRepository from '@/js/common/Domain/Repository/Countries';
import HotelsRepository from '@/js/common/Domain/Repository/Hotels';
import ExpiredPopupView from '@/js/desktop/components/expiredPopup/ExpiredPopup';
import SearchRouter from '@/js/common/Domain/Router/SearchRouter';
import ProgressBar from '@/js/desktop/components/progressBar/progress-bar';
import fromRouterHotel from '@/js/common/services/fromRouterHotel';
import toLocalStorageTourCriteriaHydrator from '@/js/common/Domain/Hydrator/toLocalStorageTourCriteria';
import SearchRequestFactory from '@/js/common/Domain/Factory/SearchRequest';
import CheckInDateRangeFactory from '@/js/common/Domain/Factory/checkInDateRange/CheckInDateRange';
import gaAsync from '@/js/common/Domain/Service/gaAsync';
import tourCriteriaHotelService from '@/js/common/Domain/Service/tourCriteriaHotel';
import backboneModelDeepInstanceOf from '@/js/common/Domain/Service/backboneModelDeepInstanceOf';
import { propsDecorator } from '@/js/common/Domain/Service/mixins/decorators';
import expandRequestCriteriaDates from '@/js/common/Domain/Service/hotelSearch/services/expandRequestCriteriaDates';
import getStore from '@ve/services/getStore/getStore';
import tourDescriptionStatistic from '@/js/common/Service/hotelPage/tourDescriptionStatistic';
import trackingService from '@/js/common/Domain/Service/tracking/tracking';
import mindBoxService from '@/js/common/Service/mindBoxService/MindBoxServiceDesktop';
import ClosedCountryBanner from '@/js/common/components/closedCountryBanner';
import ErrorCreateQuoteDb from '@/js/desktop/components/errorCreateQuoteDg/errorCreateQuoteDg';
import HotelOffersTariffPopupAdapter
    from '@ve/components/hotel/hotelOffersTariffsPopup/desktop/HotelOffersTariffPopupAdapter.vue';
import hotelOffersTariffsAdapter from '@/js/common/components/hotelOffersSearch/service/hotelOffersTariffsAdapter';
import hotelOfferRedirectService from '@/js/common/Domain/Service/hotelOfferRedirectService';
import trackingHotelSearch from '@/js/common/Domain/Service/tracking/trackingHotelSearchData/trackingHotelSearch';
import trackingHotelSupplierPrices from '@/js/common/Domain/Service/tracking/trackingHotelSupplierPricesData/trackingHotelSupplierPrices';

import RailwayToursListPopupAdapter
    from '@ve/components/railwayTours/railwayToursListPopup/desktop/RailwayToursListPopupAdapter.vue';
import { railwayToursListAdapter } from '@/js/common/components/railwayTours/Domain/service/railwayToursListAdapter';
import railwayTourRedirect from '@/js/common/components/railwayTours/Domain/service/railwayTourRedirect';

import FactoryProductsAdapt from '@ve/pages/hotel/adapters/FactoryProductsAdapt';

import hotelPageFiltersAdapterStore from '@ve/components/hotel/filters/common/store/hotelPageFiltersAdapterStore';
import HotelPageFilters from '@ve/components/hotel/filters/desktop/HotelPageFilters.vue';
import MealsRepository from '@/js/common/Domain/Repository/Meals';
import MealsForPostFilteringRepository from '@/js/common/Domain/Repository/MealsForPostFiltering';
import RoomDescriptionDialog from '@ve/components/roomDescriptionDialog/desktop/RoomDescriptionDialog.vue';
import getArrayProductsDataAdapter from '@ve/pages/hotel/adapters/getArrayProducts';
import SearchDataStore from '@ve/pages/serp/store/SearchDataStore';
import SearchFormStore, { NAMESPACE as MAP_FOR_SEARCH_FORM } from '@ve/pages/serp/store/SearchFormStore';
import NoToursInStaticDesktop from '@ve/components/banners/noToursInStaticBanner/NoToursInStaticDesktop.vue';
import NoToursInStaticStore from '@ve/components/banners/noToursInStaticBanner/store';
import EmptySearch from '@ve/components/hotel/emptySearch/desktop/EmptySearch.vue';
import { FsaRegistry } from '@fr/fsd/entities/fsaRegistry';
import hotelPageEmptySearchStore, {
    NAMESPACE as HOTEL_PAGE_EMPTY_SEARCH_STORE,
} from '@ve/components/hotel/emptySearch/common/store/hotelPageEmptySearchStore';
import toRouterHydrator from "@/js/common/Domain/Hydrator/toRouter";
import SearchFormAutocompleteView from '@/js/desktop/components/searchFormAutocomplete/SearchFormAutocomplete';
import { isEmiratesAvailable } from '@features/tourProduct/filterTourProducts';
import { productTypes } from '@fr/constants';

import TourProductView from '../TourProduct/TourProduct';

import tourSearchService from './service/tourSearchService';

import IsAbsentView from '../isAbsent/isAbsent';
import SearchFormHotelView from '../searchForm/searchForm';

import './tourSearch.css';

const TOUR_SERP_URL = '/search#?';
const RAILWAY_SERP_URL = '/railways/search#?';

const searchService = new HotelPageSearch();
const tourProductsCollection = new TourProductsRepository();
const ADVCake = new ADVCakeService('hotel');
let debuouncedMindbox = null;
@propsDecorator({
    collection: tourProductsCollection,
    itemView: TourProductView,
    progressBarTimer: null,
    subview: {
        progressBar: null,
    },
    events: {
        'click .js-hotel-offer-static-handler': 'hotelOfferStaticClick',
    },
})
export default class TourSearchView extends Backbone.Epoxy.View {// hotelPage ?
    initialize(options) {
        this.init(options);
        this.initEvents();
        this.initModelEvents();
        this.initDOMEvents();
        this.initSubViews();
        this.initVueComponents();
        this.initSubscribes();

        this.searchFormModel.get('checkInDateRange').setNull();
    }

    hotelOfferStaticClick() {
        this.formSubmit();
    }

    staticOfferClick(event) {
        const tourProductView = new TourProductView({
            model: new Backbone.Model({
                id: $(event.currentTarget).data('id'),
            }),
        });

        tourProductView.tourSelected({
            currentTarget: $('.HtlTrItemBase', event.currentTarget),
        });
    }

    // Поле «Куда» активно по умолчанию: гасим его только для отельной вертикали,
    // где сменить отель из формы поиска нельзя.
    isVisibleAutocompleteForm() {
        return this.initUrlParams?.searchSource !== productTypes.HOTEL_OFFER;
    }

    initSearchForm() {
        const form = document.querySelector('#mainSearchForm');
        if(this.isVisibleAutocompleteForm()) {
            document.querySelector('.formControl.hotel')?.remove();
            this.searchFormView = new SearchFormAutocompleteView({
                touristsGroupVariants: ['турист', 'туриста', 'туристов'],
            });
        } else {
            document.querySelector('.formControl.destination')?.remove();
            this.searchFormView = new SearchFormHotelView({
                parentView: this,
                touristsGroupVariants: ['турист', 'туриста', 'туристов'],
            }); 
        }
    }

    init(options) {

        this.initUrlParams = fromRouterHotel(window?.location?.href);
        
        this.initSearchForm();
 
        this.model = tourSearchService(tourProductsCollection);
        this.currentSearchModel = new TourCriteriaObjectValue();

        this.searchFormModel = this.searchFormView.model;

        this.parentView = options.parentView;

        this.model.view = this;

        this.hotelTrackingService = new HotelTrackingService();
        this.hotelTrackingService.setPriceJumpTrackingService(new HotelPagePriceJumpTrackingService());
        new ExpiredPopupView({
            el: '#expiredContainer',
            searchPageViewModel: this.model,
            updateResultCallback: () => {
                this.formSubmit();
                this.hotelTrackingService.priceJumpTracking.allowTrackHotelJumpCacheAndSearch();
            },
        });

        if (ls.get('isAbsent')) {
            new IsAbsentView({
                el: '.js-tour-was-sold',
                model: this.model,
            });

            this.parentView.dataLayerAnalytics.generateEvent('soldOut', '');
        }
        ls.set('isAbsent', false);
    }

    moveSimilarEl() {
        const $similar = $('.js-similar');
        const $labelH1 = $('.similar-hotel__title');

        $labelH1
            .text('Похожие отели в других странах');
        $similar
            .removeClass('order3')
            .addClass('order2');
    }

    getSelectedProductType() {
        return this.model.get('filterCriteria').get('productType');
    }

    getSerpBaseUrl() {
        return this.initUrlParams?.searchSource === productTypes.RAILWAY_TOUR
            ? RAILWAY_SERP_URL
            : TOUR_SERP_URL;
    }

    redirectByDestinations() {
        const router = new SearchRouter().getInstance();
        const hotels = this.searchFormView.model.get('hotels');
        const initialHotelId = window.appConfig.hotelInfo.id;
        const initialCountryId = +window.appConfig.hotelInfo.country;

        const currentTourCriteria = this.searchFormModel.getTourCriteria();
        const searchSource = this.initUrlParams?.searchSource;

        const setInitialHotel = () => {
            this.searchFormView.model.get('resorts').setNull();
            this.searchFormView.model.get('countries').setNull();
            this.searchFormView.model.get('hotels').setNull();
            const currentHotels = new HotelsRepository();
            const currentCountries = new CountriesRepository();
            const country = CountriesRepository.repository.get({ id: initialCountryId });
            const hotel = HotelsRepository.repository.get({ id: initialHotelId });
            currentHotels.add(hotel);
            currentCountries.add(country);
            currentHotels.manuallyChanged = true;
            currentCountries.manuallyChanged = true;
            this.searchFormView.model.get('hotels').set('model', currentHotels,  { initiator: 'view' });
            this.searchFormView.model.get('countries').set('model', currentCountries,  { initiator: 'view' });
        }
        if (hotels.get('model').length === 0) {
            const paramsForSerp = toRouterHydrator(currentTourCriteria);
            setInitialHotel();
            router.go(`${this.getSerpBaseUrl()}${$.param(paramsForSerp)}`, {}, true);
            return;
        }

        if(initialHotelId !== hotels.get('model').at(0).get('id')) {
            const hotelUrl = hotels.get('model').at(0).get('url');
            const isRailwaySearchSource = searchSource === productTypes.RAILWAY_TOUR;

            const paramsForRouter = toRouterHotelHydrator({
                tourCriteria: currentTourCriteria,
                identity: null,
                productType: isRailwaySearchSource ? this.getSelectedProductType() : undefined,
                searchSource,
                sid: searchSessionService.getSearchId(),
                hsid: searchSessionService.getHotelSearchId(),
            });
            setInitialHotel();
            router.go(`${hotelUrl}#?${$.param(paramsForRouter)}`, {}, true);
        }
    }

    initEvents() {
        const router = new SearchRouter().getInstance();
        router.on('route', $.proxy(this.changeRouteInit, this));

        this.model.on('change:sortStrategy', this.sortStrategyChanged.bind(this));
        this.model.on('change:loadingState', this.changeLoadingState.bind(this));
        this.currentSearchModel.on('change', () => {
            const store = getStore();
            const isPairOfDepartureCityAndArrivalCountryAreValid = store.getters[`${MAP_FOR_SEARCH_FORM}/isPairOfDepartureCityAndArrivalCountryAreValid`];
            const country = store.state[MAP_FOR_SEARCH_FORM].countries[0];
            const departureCity = store.state[MAP_FOR_SEARCH_FORM].departureCity;
            if (!isPairOfDepartureCityAndArrivalCountryAreValid) {
                this.resetDirectFlightFilter();
            }
            if(!isEmiratesAvailable(departureCity, country)) {
                this.resetEmiratesFilter();
            }

            this.goSearch.call(this, this.currentSearchModel);
        });

        this.searchFormModel.get('warranted').on('change:model', this.changeFilterAsCriteria.bind(this));
        this.searchFormModel.get('directFlight').on('change:model', this.changeFilterAsCriteria.bind(this));
        this.searchFormModel.get('block').on('change:model', this.changeFilterAsCriteria.bind(this));

        this.model.get('filterCriteria').on('change:productType', () => {
            this.changePagesRouteWithoutReload();
            this.model.trigger('change:syncTourProducts');
            this.toggleDepartureCityByProductType();
        });
        this.toggleDepartureCityByProductType();

        this.on('startSeach', this.manuallyFormSubmit.bind(this));
        this.on('createQuoteError', (message) => {
            this.createQuoteBanner = new ErrorCreateQuoteDb({
                type: 'hotelOffer',
                rootView: this,
                message,
            });
        });

        this.on('selectedHotelOfferGroup', this.hotelOfferGroupSelected.bind(this));
        this.on('selectedRailwayToursGroup', this.railwayToursGroupSelected.bind(this));
        this.on('openRoomDescriptionDialog', this.openRoomDescriptionDialog.bind(this));
    }

    openRoomDescriptionDialog(tourProduct) {
        this.roomDescriptionDialog.open();
        this.roomDescriptionDialogData.products = getArrayProductsDataAdapter(tourProduct);
    }

    railwayToursGroupSelected(options) {
        const store = getStore();
        store.commit('railwayToursListStore/railwayToursListChanged',
            railwayToursListAdapter(options.railwayTours.map((railwayTour) => FactoryProductsAdapt(railwayTour))));
        this.railwayToursListPopup.open();
    }

    hotelOfferGroupSelected(options) {
        const store = getStore();
        store.commit('hotelOffersTariffsStore/tariffsChanged',
            hotelOffersTariffsAdapter(options.hotelOffers.map((hotelOffer) => FactoryProductsAdapt(hotelOffer))));
        this.roomProvidersTracking = options.tracking ?? null;
        this.tariffSelected = false;
        this.hotelOffersTariffPopup.open();
        this.roomProvidersTracking?.tariffsOpen();
    }

    changePagesRouteWithoutReload() {
        const currentTourCriteria = this.searchFormModel.getTourCriteria();
        const selectedProductType = this.getSelectedProductType();

        const paramsForRouter = toRouterHotelHydrator({
            tourCriteria: currentTourCriteria,
            identity: null,
            productType: selectedProductType,
            searchSource: this.initUrlParams?.searchSource,
            sid: searchSessionService.getSearchId(),
            hsid: searchSessionService.getHotelSearchId(),
        });

        const router = new SearchRouter().getInstance();
        router.go(`?${$.param(paramsForRouter)}`, { replace: true, type: 'default' });
    }

    manuallyFormSubmit() {
        this.formSubmit({ goToHotelPage: false, openBooking: false });
    }

    changeFilterAsCriteria(event, model, context) {
        if (context && (context.initiator === 'view' || context.initiator === 'filtersPopover')) {
            this.manuallyFormSubmit();
        }
    }

    initDOMEvents() {
        this.searchFormFix();
        if(this.isVisibleAutocompleteForm()) {
            $('.startSearch').on('click', this.redirectByDestinations.bind(this));
        }
        $('.startSearch').on('click', this.formSubmit.bind(this));
    }

    initModelEvents() {
        this.model.on('change:departureCityName', $.proxy(this.changeDepartureCityName, this));

        this.collection.on('change', _.debounce(() => {
            tourDescriptionStatistic(this.collection);
        }, 10));
    }

    searchFormFix() {
        const $form = $('.hotel-page-header-form');
        const $formHeaderContainer = $('.hotel-page-header-form__container');
        $(window).on('scroll', function () {
            const { top } = $form.offset();
            const scrollTop = $(this).scrollTop();
            if (scrollTop > top) {
                $form.addClass('formFix');
            } else {
                $form.removeClass('formFix');
                $formHeaderContainer.removeClass('minimized');
            }
        });
    }

    changeDepartureCityName() {
        $('.js-departureCityName').html(this.model.get('departureCityName'));
    }

    toggleDepartureCityByProductType() {
        const isOnlyHotelSelected = this.model.get('filterCriteria').get('productType') === 'hotelOffer';
        $('.hotelContent__departureCity').toggleClass('hotelContent__departureCity_hidden', isOnlyHotelSelected);
    }

    initSubViews() {
        this.subview.progressBar = new ProgressBar('.js-hotel-progress-bar');

        this.closedCountryBanner = new ClosedCountryBanner({
            el: '.js-component-closed-country-banner',
            model: this.model,
            type: 'hotel',
        });
    }

    initVueComponents() {
        useVueCompositionApi();
        this.initFilters();

        this.initHotelOffersTariffPopup();
        this.initRoomDescriptionPopup();
        this.initRailwayToursListPopup();
        this.initNoToursInStaticBanner();
        this.initEmptySearch();
        this.initFsaRegistry();
        this.initLeadBanner();
        this.initLibSearchForm();
    }

    initLibSearchForm() {
        const store = getStore();
        const controller = { model: this.searchFormModel, formSubmit: () => {
            if(this.isVisibleAutocompleteForm()) {
                this.redirectByDestinations();
            }
            this.formSubmit()
        }, };
        $('.menuContainer').hide();
        $('.searchFormContainer').hide();
        mountLibSearchForm({
            store,
            controller,
            vertical: 'hotelPage',
            flow: getHotelPageFlow(this.initUrlParams?.searchSource),
        });
    }

    initLeadBanner() {
        const isLeadSessionActive = checkLeadSession();
        if (isLeadSessionActive) return;

        const showMoreEl = document.querySelector('.hotelToursList__show-more-hotels');
        if (!showMoreEl) {
            return;
        }

        const leadBannerEl = document.createElement('div');
        showMoreEl.parentNode.insertBefore(leadBannerEl, showMoreEl);

        new Vue({
            render: (h) => h(HotelLeadBanner),
            store: getStore(),
        }).$mount(leadBannerEl);
    }

    initFilters() {
        const store = hotelPageFiltersAdapterStore({
            tourSearchModel: this.model,
            searchFormModel: this.searchFormModel,
            currentSearchModel: this.currentSearchModel,
            mealsRepository: MealsForPostFilteringRepository.repository,
        });

        SearchFormStore({ model: this.searchFormModel });
        SearchDataStore({ model: this.model });


        const filtersComponent = new Vue({
            name: 'HotelPageFilters',
            render: (h) => h(HotelPageFilters),
            store,
        }).$mount('#hotelPageFilters');

        filtersComponent.$on('start-new-search', (date) => {
            const modifiedTourCriteria = this.currentSearchModel.clone();
            modifiedTourCriteria.set('checkInDateRange', new CheckInDateRangeFactory({
                from: date,
                to: date,
            }));
            this.goSearch(modifiedTourCriteria, {
                additionalSearchHotelPage: true,
            });
        });

        filtersComponent.$on('operator-filter-changed', () => {
            this.hotelTrackingService.operatorsFilterClick();
        });

        filtersComponent.$on('meal-filter-changed', (meals) => {
            this.hotelTrackingService.mealsFilterClick();
            const mealsToSet = MealsForPostFilteringRepository.repository.filter((meal) => !!~meals.indexOf(meal.get('id')));
            this.searchFormModel.get('meals').set('model', new MealsRepository(mealsToSet));
            if (!this.model.get('beforeToursLoading')) {
                this.changePagesRouteWithoutReload();
            }
        });

        filtersComponent.$on('warranted-filter-changed', (warranted) => {
            this.searchFormModel.get('warranted').set({
                model: warranted,
            }, { initiator: 'view' });
        });

        filtersComponent.$on('direct-flight-changed', (directFlight) => {
            this.searchFormModel.get('directFlight').set({
                model: directFlight,
            }, { initiator: 'view' });
        });
        filtersComponent.$on('block-changed', (value) => {
            this.searchFormModel.get('block').set({
                model: value,
            }, { initiator: 'view' });
        });

        filtersComponent.$on('prepayment-filter-changed', (prepayments) => {
            this.model.get('filterCriteria').set('prepayments', prepayments);
        });

        filtersComponent.$on('bonus-miles-changed', (bonusMiles) => {
            this.model.get('filterCriteria').set('bonusMiles', bonusMiles);
        });
        filtersComponent.$on('mir-cashback-changed', (mirCashback) => {
            this.searchFormModel.get('mirCashback').set({
                model: mirCashback,
            }, { initiator: 'view' });
            this.model.get('filterCriteria').set('mirCashback', mirCashback);
        });
    }

    initRoomDescriptionPopup() {
        const store = getStore();
        const dialog = document.createElement('div');
        dialog.className = 'js-roomDescriptionDialog';
        document.getElementsByTagName('body')[0].appendChild(dialog);

        this.roomDescriptionDialogData = reactive({
            products: null,
        });

        [this.roomDescriptionDialog] = new Vue({
                name: 'RoomDescriptionDialog',
                render: (h) => h(RoomDescriptionDialog, {
                props: {
                    dialogData: this.roomDescriptionDialogData,
                },
            }),
            store,
        }).$on('hotel-offers-tariff-open', (hotelOffers) => {
            store.commit('hotelOffersTariffsStore/tariffsChanged', hotelOffersTariffsAdapter(hotelOffers));
            this.hotelOffersTariffPopup.open();
        }).$on('railway-open-popup', (railwayTours) => {
            store.commit('railwayToursListStore/railwayToursListChanged', railwayToursListAdapter(railwayTours));
            this.railwayToursListPopup.open();
        }).$mount('.js-roomDescriptionDialog').$children;
    }

    initFsaRegistry() {
        const fsaRegistryInfo = window.appConfig?.hotelInfo?.fsaRegistry;

        if (!fsaRegistryInfo?.number) {
            return;
        }

        new Vue({
            name: 'FsaRegistry',
            render: (h) => h(FsaRegistry, {
                props: {
                    fsaRegistryInfo,
                }
            }),
        }).$mount('.fsa-registry-js');
    }

    tabDatesNewSearch() {
        const store = getStore();
        store.dispatch('mapForDatesTabs/startedNewSearch');
    }

    initHotelOffersTariffPopup() {
        const store = getStore();
        $('body').append('<div class="js-tariffs-popup-wrapper"></div>');

        //тут беру $children потому что мне нужно далее вызывать метод open именно у инстанса компоненты HotelOffersTariffPopupAdapter а не у родительской компоненты
        [this.hotelOffersTariffPopup] = new Vue({
            name: 'HotelOffersTariffPopup',
            render: (h) => h(HotelOffersTariffPopupAdapter, {
                on: {
                    close: () => {
                        if (!this.tariffSelected) this.roomProvidersTracking?.tariffsClose();
                    },
                },
            }),
            store,
        }).$on('hotel-offer-tariff-selected', (tariff) => {
            this.tariffSelected = true;
            this.roomProvidersTracking?.tariffsClick();
            mindBoxService.trackGoToCheckoutHotelOffer(this.model, tariff);

            hotelOfferRedirectService(tariff.tourId, {
                success: (url) => {
                    window.location.href = url;
                },
                error: (message) => {
                    this.hotelOffersTariffPopup.close();
                    this.trigger('createQuoteError', message);
                },
            });
        }).$mount('.js-tariffs-popup-wrapper').$children;
    }

    initNoToursInStaticBanner() {
        const store = NoToursInStaticStore({
            model: this.model,
        });

        if (!window.appConfig?.noToursFound) {
            return;
        }

        new Vue({
            name: 'NoToursInStaticDesktop',
            render: (h) => h(NoToursInStaticDesktop, {
                props: {
                    isMarginShouldBeAdded: true,
                },
                on: {
                    'update-search-click': () => {
                        this.formSubmit();
                    },
                },
            }),
            store,
        }).$mount('.js-serp-no-static-banner');
    }

    initRailwayToursListPopup() {
        const store = getStore();
        $('body').append('<div class="js-railways-tours-list-popup-wrapper"></div>');

        //тут беру $children потому что мне нужно далее вызывать метод open именно у инстанса компоненты RailwayToursListPopupAdapter а не у родительской компоненты
        [this.railwayToursListPopup] = new Vue({
            name: 'RailwayToursListPopup',
            render: (h) => h(RailwayToursListPopupAdapter),
            store,
        }).$on('select-railway-tour', (railwayTourIdentity) => {
            const hotelId = this.parentView.model.get('hotelInfo').id;
            railwayTourRedirect(hotelId, [railwayTourIdentity]);
        }).$mount('.js-railways-tours-list-popup-wrapper').$children;
    }

    initEmptySearch() {
        const store = hotelPageEmptySearchStore({
            tourSearchModel: this.model,
        });
        const router = new SearchRouter().getInstance();

        new Vue({
            name: 'EmptySearch',
            render: (h) => h(EmptySearch, {
                on: {
                    'select-another-date': (e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        $('.formDropdownWithCalendar.tour-duration .formInputPlace')?.trigger('click');
                        document.querySelector('.date-from-field .field__control')?.click();
                    },
                    'select-another-city': (e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        $('#mainSearchForm .from_city a').trigger('click');
                        document.querySelector('.departure-city-field .field__control')?.click()
                    },
                    'select-specific-city': ({ event, id }) => {
                        event.preventDefault();
                        event.stopPropagation();
                        const url = this.getUrlWithGivenFromCityId(id);
                        router.go(url, { replace: true });
                    },
                },
            }),
            store,
        }).$mount('.search-empty');

        store.watch((state, getters) => [
            getters[`${HOTEL_PAGE_EMPTY_SEARCH_STORE}/isShouldRenderAnotherProductsBlock`],
            state[HOTEL_PAGE_EMPTY_SEARCH_STORE].syncTourProductsOnSelectedDateAdapted,
        ], (newValue) => {
            if (newValue[0]) this.model.updateTourProductsCollection(this.model.get('syncTourProductsOnSelectedDate'));
            else this.model.updateTourProductsCollection(this.model.get('filteredTourProducts'));
        });
    }

    getUrlWithGivenFromCityId(id) {
        const searchData = this.model.get('searchData');
        let params;
        let url = '';

        if (searchData) {
            params = toRouterHotelHydrator({
                tourCriteria: searchData,
                identity: null,
                productType: this.getSelectedProductType(),
                searchSource: this.initUrlParams?.searchSource,
                sid: searchSessionService.getSearchId(),
                hsid: searchSessionService.getHotelSearchId(),
            });
            params.fromCity = id;
            url = `#?${$.param(params)}`;
        }

        return url;
    }

    changeRouteInit(type, url) {
        const urlResult = _.isArray(url) ? url[0] : url;
        const hotelInfo = this.parentView.model.get('hotelInfo');
        const additionalData = { setTourCriteria: typeof window.appConfig.defaultTourCriteria !== 'undefined' ? window.appConfig.defaultTourCriteria : {} };

        if (type === 'search') {
            this.model.set('beforeToursLoading', false);
            this.changeRouteInit = this.routeChanged;
            this.routeChanged(type, urlResult, additionalData.setTourCriteria);
            this.model.trigger('change:routerChanged');
        } else {
            this.searchFormModel.get('countries').setNull();
            this.searchFormModel.get('resorts').setNull();
            this.searchFormModel.get('hotels').setNull();
            this.searchFormModel.get('checkInDateRange').setNull();
            this.searchFormModel.get('nightRange').setNull();
            this.searchFormModel.get('touristGroup').setNull();
            this.searchFormModel.get('hotelCategories').setNull();
            this.searchFormModel.get('meals').setNull();
            this.searchFormModel.get('priceRange').setNull();

            searchSessionService.generateNewHotelSearchId();

            tourCriteriaHotelService.loadTourCriteriaWithFormDataHotel(additionalData, {
                success: (tourCriteria) => {
                    this.searchFormModel.setTourCriteria(tourCriteria, true);
                    this.parentView.dataLayerAnalytics.initBasicEventsHotel(tourCriteria);
                },
            }, hotelInfo);
        }
    }

    routeChanged(type, url, additionalData) {
        let paramsFromUrl = {};
        const hotelInfo = this.parentView.model.get('hotelInfo');

        const loadTourCriteriaWithFormDataForHotel = (params, callback) => {
            tourCriteriaHotelService.loadTourCriteriaWithFormDataHotel(params, {
                success: (tourCriteria) => {
                    this.searchFormModel.setTourCriteria(tourCriteria, true);
                    callback();
                },
                error() {
                },
            }, hotelInfo);
        };

        if (type === 'search') {
            paramsFromUrl = fromRouterHotel(_.isArray(url) ? url[0] : url);
        } else {
            if (additionalData) {
                paramsFromUrl.tourCriteria = additionalData;
            }
            tourCriteriaHotelService.clearTourCriteriaChangedFields();
        }

        //set store productType field
        if (paramsFromUrl.productType) {
            const productType = paramsFromUrl.productType === 'tourOffer'
                ? 'all'
                : paramsFromUrl.productType;
            this.model
                .get('filterCriteria')
                .set('productType', productType);
        }

        if (paramsFromUrl.tourCriteria.meals?.length) {
            this.model
                .get('filterCriteria')
                .set('meals', paramsFromUrl.tourCriteria.meals);
        }
        if (paramsFromUrl.prepayments?.length) {
            this.model
                .get('filterCriteria')
                .set('prepayments', paramsFromUrl.prepayments);
        }
        if (paramsFromUrl.bonusMiles) {
            this.model
                .get('filterCriteria')
                .set('bonusMiles', true);
        }

        if (paramsFromUrl.selectedOperators) {
            const operators = Object.values(paramsFromUrl.selectedOperators).map(Number);
            this.model.get('filterCriteria').set('operators', operators);
        }

        if (paramsFromUrl.bonusMiles) {
            this.searchFormModel.get('bonusMiles').set('model', paramsFromUrl.bonusMiles);
            this.model.get('filterCriteria').set('bonusMiles', paramsFromUrl.bonusMiles);
        }

        if (paramsFromUrl.mirCashback) {
            this.searchFormModel.get('mirCashback').set('model', paramsFromUrl.mirCashback);
            this.model.get('filterCriteria').set('mirCashback', paramsFromUrl.mirCashback);
        }

        if (paramsFromUrl.identity) {
            this.model.set('selectedIdentity', paramsFromUrl.identity);
        }

        if (paramsFromUrl.sid) {
            searchSessionService.setSearchId(paramsFromUrl.sid);
        }

        if (paramsFromUrl.hsid) {
            searchSessionService.setHotelSearchId(paramsFromUrl.hsid);
        } else {
            searchSessionService.generateNewHotelSearchId();
        }

        this.model.set('hot', false);
        this.parentView.model.set('hot', false);
        this.model.set('selectedIdentity', false);
        this.model.set('urlParams', $.unparam(url));

        loadTourCriteriaWithFormDataForHotel({ setTourCriteria: paramsFromUrl.tourCriteria }, () => {
            const currentTourCriteria = this.searchFormModel.getTourCriteria();
            const paramsForRouter = toRouterHotelHydrator({
                tourCriteria: currentTourCriteria,
                identity: this.model.get('selectedIdentity'),
                sid: searchSessionService.getSearchId(),
                hsid: searchSessionService.getHotelSearchId(),
                productType: this.getSelectedProductType(),
                searchSource: this.initUrlParams?.searchSource,
            });
            const router = new SearchRouter().getInstance();

            router.go(`?${$.param(paramsForRouter)}`, { replace: true });
            this.currentSearchModel.set(currentTourCriteria.attributes);
            this.model.set('searchData', currentTourCriteria);
        });
    }

    sortStrategyChanged() {
        this.model.set('pageNumber', 1, { silent: true });
        this.collection.reset();
        this.model.get('filteredTourProducts').sort();
        this.model.trigger('change:filteredTourProducts');
        this.scrollToTop();
    }

    clearFilterCriteria() {
        this.model.get('filterCriteria').set('selectedTabDate', 0);
    }

    formSubmit() {
        const currentTourCriteria = this.searchFormModel.getTourCriteria();
        const selectedProductType = this.getSelectedProductType();

        searchSessionService.changeHotelSearchIdForNewSearch({
            oldSearchCriteria: this.model.get('searchData'),
            newSearchCriteria: currentTourCriteria,
        });

        const paramsForRouter = toRouterHotelHydrator({
            tourCriteria: currentTourCriteria,
            identity: null,
            productType: selectedProductType,
            searchSource: this.initUrlParams?.searchSource,
            sid: searchSessionService.getSearchId(),
            hsid: searchSessionService.getHotelSearchId(),
        });

        if (currentTourCriteria.isValid() && this.searchFormView.isValid()) {
            if (this.parentView.dataLayerAnalytics) {
                this.parentView.dataLayerAnalytics.clickSearchButtonEvent();
            }
            this.model.set('hot', false);
            this.parentView.model.set('hot', false);
            this.model.set('beforeToursLoading', false);
            this.model.set('selectedIdentity', false);

            const router = new SearchRouter().getInstance();
            const paramsForLocalStorage = toLocalStorageTourCriteriaHydrator(currentTourCriteria);
            const forceChangeTrigger = _.isEqual(this.currentSearchModel.attributes, currentTourCriteria.attributes);

            if ($.cookie) {
                $.cookie('markSearchSource', true, { path: '/', domain: 'all' });
            }

            delete (paramsForLocalStorage.resorts);
            ls.set('tourCriteria', paramsForLocalStorage);

            router.go(`?${$.param(paramsForRouter)}`, { replace: true });

            this.currentSearchModel.set(currentTourCriteria.attributes);

            this.model.set('identity', null);
            this.model.set('searchData', currentTourCriteria);

            //to force search with same params
            if (forceChangeTrigger) {
                this.currentSearchModel.trigger('change', this.currentSearchModel);
            }
            this.model.set('subscribe', '0');
            this.gotoSearchResults();
        }
    }

    resetBanners() {
        this.model.set('countryIsClose', false);
    }

    showCountryIsClosedBanner() {
        this.model.set('countryIsClose', true);
        this.model.set('loadingState', 'finished');

        this.moveSimilarEl();
    }

    isAllowed(tourCriteria) {
        const from = tourCriteria.get('checkInDateRange')?.get('from');
        const to = tourCriteria.get('checkInDateRange')?.get('to');
        const disabledBefore = moment(window.appConfig.disabledBefore);

        if (!disabledBefore.isValid()) {
            return true;
        }

        return moment(from).isAfter(disabledBefore)
            && moment(to).isAfter(disabledBefore);
    }

    minboxTracking() {
        const trackViewHotelData = mindBoxService.trackViewHotelAdapter(this);

        mindBoxService.trackViewHotel({
            idHotel: window.appConfig?.hotelInfo?.id,
            ...trackViewHotelData,
        });
    }

    resetDirectFlightFilter() {
        this.currentSearchModel.set('directFlight', false, { silent: true });
        this.searchFormModel.get('directFlight').set({ model: false });
        this.changePagesRouteWithoutReload();
    }

    resetEmiratesFilter() {
        this.currentSearchModel.set('block', false, { silent: true });
        this.searchFormModel.get('block').set({ model: false });
        this.changePagesRouteWithoutReload();
    }

    goSearch(tourCriteria, params) {
        if (!this.goSearch.counter) this.goSearch.counter = 1;
        else this.goSearch.counter += 1;

        const searchServiceParamsCollection = [];

        let searchCounter;

        if (!this.isAllowed(tourCriteria)) {
            this.showCountryIsClosedBanner();
            return;
        }

        this.resetBanners();
        clearInterval(this.progressBarTimer);
        if (tourCriteria.isValid()) {
            if (!params?.additionalSearchHotelPage) {
                this.tabDatesNewSearch();
            }
            trackingService.generateSearchUuid();
            searchCounter = this.model.get('searchStartCounter');
            this.model.set('searchStartCounter', ++searchCounter);
            this.parentView.model.set('tourSearchCriteria', tourCriteria, { silent: true });
            this.parentView.model.trigger('change:tourSearchCriteria');
            this.model.set('loadingState', 'loading');
            this.model.set('loadingInProgress', true);

            const searchCriteria = !params?.additionalSearchHotelPage ? expandRequestCriteriaDates(tourCriteria) : tourCriteria;
            searchCriteria.set('meals', new MealsRepository());

            searchServiceParamsCollection.push(new SearchRequestFactory(searchCriteria, 'sync'));
            searchServiceParamsCollection.push(new SearchRequestFactory(searchCriteria, 'async'));

            gaAsync(() => {
                ga('send', 'event', 'Request', 'Async', 'from_hotel_page');
            });
            console.log('Async request from hotel page sent');

            const finished = {
                sync: false,
                async: false,
            };

            this.initProgressBar(finished);
            this.clearFilterCriteria();

            const searchServiceRequest = (searchServiceTourCriterias) => {
                searchService.getTourProducts({
                    searchUuid: trackingService.getSearchUuid(),
                    requests: searchServiceTourCriterias,
                    callback: {
                        sync: (tourProducts) => {
                            tourProducts.each((tourProduct) => {
                                tourProduct.initComputeds();
                            });

                            if (tourProducts.length > 0) {
                                //note цена берется из hotelOffer, т.к он выходит самым дешевым
                                const price = tourProducts.at(0).get('product')?.get('price');
                                ADVCake.updateSearchData(tourCriteria, price);

                                this.model.set('loadingInProgress', false);
                                this.collection.reset();
                                this.model.set('pageNumber', 1, { silent: true });
                                this.model.set('syncTourProducts', tourProducts, { silent: true });
                                this.model.trigger('change:syncTourProducts');
                            } else {
                                this.model.set('syncTourProducts', tourProducts, { silent: true });
                            }

                            finished.sync = true;

                            if (finished.async) {
                                if (this.model.get('loadingInProgress')) {
                                    this.model.set('loadingInProgress', false);
                                    this.collection.reset();
                                    this.model.set('pageNumber', 1, { silent: true });
                                    if (tourProducts && tourProducts.length === 0) {
                                        this.model.set('syncTourProducts', tourProducts);
                                    }
                                }

                                this.model.set('loadingState', 'finished');
                                clearInterval(this.progressBarTimer);
                                this.subview.progressBar.complete();
                            }

                            this.sendAnalyticsBySyncSearchSuccses(params);
                        },
                        middleRequest: (tourProducts) => {
                            const previousTourProducts = this.model.get('syncTourProducts');

                            _.each(tourProducts, (tourProduct) => {
                                tourProduct.initComputeds();
                            });

                            if (previousTourProducts && !previousTourProducts.length && tourProducts && tourProducts.length) {
                                ADVCake.updateSearchData(tourCriteria, previousTourProducts.at(0).get('tour').get('price'));
                            }

                            if (tourProducts.length) {
                                this.model.set('loadingInProgress', false);
                                if (finished.async) {
                                    this.model.set('loadingState', 'finished');
                                    clearInterval(this.progressBarTimer);
                                    this.subview.progressBar.complete();
                                } else {
                                    this.model.set('loadingState', 'asyncLoading');
                                }
                                this.model.trigger('change:syncTourProducts');
                            }
                        },
                        async: (tourProducts, options, tourProductsRepository) => {
                            const previousTourProducts = this.model.get('syncTourProducts');
                            if (tourProducts && tourProducts.length === 0) {
                                gaAsync(() => {
                                    ga('send', 'event', 'Hotel_Card', 'Hotel_without_prices', document.location.pathname + document.location.hash, { nonInteraction: 1 });
                                });
                            }

                            if (previousTourProducts && !previousTourProducts.length && tourProducts && tourProducts.length) {
                                ADVCake.updateSearchData(tourCriteria, previousTourProducts.at(0).get('tour').get('price'));
                            }

                            if (!previousTourProducts) {
                                this.model.set('syncTourProducts', tourProductsRepository, {
                                    silent: true,
                                });
                            }

                            if (tourProducts && tourProducts.length) {
                                _.each(tourProducts, (tourProduct) => {
                                    tourProduct.initComputeds();
                                });
                                this.model.set('loadingInProgress', false);
                            }

                            if (finished.sync && (!previousTourProducts || previousTourProducts.length === 0)) {
                                this.model.set('loadingInProgress', false);
                                this.model.set('pageNumber', 1, { silent: true });
                            }

                            finished.async = true;
                            console.warn('Закончился асинхронный поиск');
                            this.asyncSearchSuccess(tourCriteria, options);

                            if ((tourProducts && tourProducts.length) || !previousTourProducts || !previousTourProducts.length) {
                                this.model.trigger('change:syncTourProducts');
                            }

                            console.log('changed', 'asyncTourProducts', 'loadingState');
                        },
                    },
                    additionalParams: {
                        notClearRepository: params?.additionalSearchHotelPage,
                    },
                });
            };

            this.model.set('asyncTourProducts', null);
            searchServiceRequest(searchServiceParamsCollection);
            this.model.trigger('change:syncTourProducts');
            if (this.parentView.dataLayerAnalytics && this.parentView.dataLayerAnalytics.hsid !== searchSessionService.getHotelSearchId()) {
                this.parentView.dataLayerAnalytics.generateEvent('hsid', searchSessionService.getHotelSearchId());
                this.parentView.dataLayerAnalytics.initBasicEventsHotel(tourCriteria);
                this.parentView.dataLayerAnalytics.hSearchCount = null;
            }

            $('.partialPaymentBanner__readMore')[moment(tourCriteria.get('checkInDateRange').get('from')).diff(moment().startOf('day'), 'days') >= 21 ? 'show' : 'hide']();
        }
    }

    sendAnalyticsBySyncSearchSuccses(searchParams) {
        debuouncedMindbox = _.debounce(
            () => { setTimeout(this.minboxTracking.bind(this), mindBoxService.mindBoxTrackTimeoutHotelPage); },
            mindBoxService.mindBoxDebounceTimeHotelPage,
        );
        const isGroupSearch = !!this.searchFormModel?.get('touristGroup')?.isGroupSearch()
        if (!searchParams?.additionalSearchHotelPage && !isGroupSearch) {
            debuouncedMindbox();
        }

        const shouldTrackTourJumpPrice = this.model.get('searchStartCounter') === 1
            && this.parentView.model.get('thereIsToursOffers');

        setTimeout(() => {
            const minPrice = this.parentView.model.get('minPriceBySearchDates');
            const urlParams = this.model.get('urlParams');
            this.hotelTrackingService.priceJumpTracking.setTourMinPriceFromCache(minPrice);

            if (shouldTrackTourJumpPrice) {
                this.hotelTrackingService.trackHotelJumpPriceFromCache(minPrice, +urlParams?.minPrice);
            }
        }, 0);
    }

    asyncSearchSuccess(tourCriteria, options) {
        const minPrice = this.model.get('minPrice');
        const shouldTrackTourJumpPrice = this.parentView.model.get('thereIsToursOffers');

        if (this.parentView.dataLayerAnalytics && backboneModelDeepInstanceOf({
            model: this.model,
            values: ['minPriceTourProduct', 'tour'],
        }) && this.model.get('searchStartCounter') === 1) {
            const tour = this.model.get('minPriceTourProduct').get('tour');
            const hotelPrices = this.parentView.dataLayerAnalytics.createRangeEvent({
                price: minPrice,
                taxoil: tour.get('oilTaxIsAbsent') ? 999999 : tour.get('oilTax'),
            });
            this.parentView.dataLayerAnalytics.generateEvent('hotelPrices', hotelPrices);
        }

        if (options) {
            const store = getStore();
            setTimeout(() => this.hotelTrackingService.trackingHotelSearch(store.getters[`${HOTEL_PAGE_EMPTY_SEARCH_STORE}/paramsForEmptySearchAnalytic`]));
            trackingHotelSearch(this.model.get('syncTourProducts'), {
                ...options,
                tourCriteria,
                model: this.model,
                searchFormModel: this.searchFormModel,
            });
            trackingHotelSupplierPrices(this.model.get('syncTourProducts'), {
                ...options,
                tourCriteria,
                model: this.model,
            });
        }

        if (shouldTrackTourJumpPrice) {
            setTimeout(() => {
                const minPriceBySearchDates = this.parentView.model.get('minPriceBySearchDates');

                this.hotelTrackingService.trackHotelJumpBetweenCacheAndSearch(minPriceBySearchDates);
            }, 0);
        }

        this.showSearchFinishedState();
    }

    showSearchFinishedState() {
        if (this.model.get('loadingInProgress')) {
            this.model.set('loadingInProgress', false);
            this.model.set('pageNumber', 1, { silent: true });
        }
        this.model.set('loadingState', 'finished');
        clearInterval(this.progressBarTimer);
        this.subview.progressBar.complete();
    }

    initProgressBar(finished) {
        this.subview.progressBar.reset();
        this.subview.progressBar.moveToValue(50);

        clearInterval(this.progressBarTimer);

        this.progressBarTimer = setInterval(() => {
            if (finished.sync) {
                const asyncStatus = searchService.getAsyncStatus();
                const { jobsCount, jobsSuccess: successfulJobsCount } = asyncStatus;
                let jobPercents = 50;

                if (jobsCount && successfulJobsCount !== jobsCount) {
                    jobPercents += (50 / jobsCount) * (successfulJobsCount + 1);
                } else {
                    jobPercents = 100;
                }

                if (jobPercents === 100) {
                    clearInterval(this.progressBarTimer);
                }

                this.subview.progressBar.moveToValue(jobPercents);
            }
        }, 1000);
    }

    initSubscribes() {
        this.model.on('change:newResultLowerPriceTourProductsFound change:additionalTourProductsFound', () => {
            const cheaperTourProductsCount = this.get('newResultLowerPriceTourProductsFound');
            const additionalTourProductsCount = this.get('additionalTourProductsFound');

            if (cheaperTourProductsCount > 0) {
                this.showAllCheapest();
            } else if (additionalTourProductsCount > 0) {
                this.showAll();
            }
        });
    }

    pageInc() {
        if (this.model.get('pageIncAvaliable')) {
            const store = getStore();
            //to prevent date change to cheapest
            store.dispatch('mapForDatesTabs/selectDateManually');
            this.model.set('pageNumber', this.model.get('pageNumber') + 1);
        }
    }

    showAll() {
        const fullTourProducts = this.model.get('asyncTourProducts');

        this.model.set('pageNumber', 1, { silent: true });
        this.collection.reset();

        this.model.set('syncTourProducts', fullTourProducts);
        this.scrollToTop();

        return false;
    }

    showAllCheapest() {
        this.model.set('sortStrategy', 'priceUp');
        this.showAll();
        return false;
    }

    scrollToTop() {
        const currenPosition = $(document).scrollTop();
        const scrollTourProductsListPosition = $('.hotelToursList').offset().top;

        if (currenPosition > scrollTourProductsListPosition) {
            $('html,body').animate({ scrollTop: scrollTourProductsListPosition }, 700);
        }
    }

    gotoSearchResults() {
        $('html,body').animate({
            scrollTop: $('.hotelContent').offset().top - 100,
        }, 500);
    }

    changeLoadingState(model, value) {
        const $similar = $('.js-similar');
        const $partialPaymentBanner = $('.partialPaymentBanner_forHotelPage');
        const tourProducts = this.model.get('syncTourProducts');

        const compareDataLayerAnalytics = (hSearchCount) => {
            const { dataLayerAnalytics } = this.parentView;
            if (!dataLayerAnalytics) {
                return;
            }
            if (dataLayerAnalytics.hSearchCount !== hSearchCount) {
                dataLayerAnalytics.generateEvent('hSearchCount', hSearchCount);
            }
        };

        if (value === 'finished' && tourProducts && !tourProducts.length) {
            $similar.removeClass('order3').addClass('order2').find('h3').hide();
            $partialPaymentBanner.addClass('alone');
            compareDataLayerAnalytics(0);
        } else {
            $similar.removeClass('order2').addClass('order3').find('h3').show();
            $partialPaymentBanner.removeClass('alone');
            compareDataLayerAnalytics(1);
        }
    }
}